import { render, staticRenderFns } from "./AccountManual.vue?vue&type=template&id=65d5dbac&scoped=true&"
import script from "./AccountManual.vue?vue&type=script&lang=js&"
export * from "./AccountManual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d5dbac",
  null
  
)

export default component.exports